export const slugString = (input: string): string => {
	return input.replace(/[^a-zA-Z- 0-9.]/g, "").replace(/\s+/g, "-")
}
